<div id="conteneur" class="w-100" >
  @if (supplierForm && supplierForm.controls) {
    <form [formGroup]="supplierForm" class="form-container" (ngSubmit)="submitForm()">
      <div class="questions">
        @for (question of surveyJsonForm.providerSurvey.survey; track question) {
          <div class="w-100">
            @if (supplierForm.controls[question.uniqueId]) {
              <ng-container class="d-block w-100">
                @switch (question.type) {
                  @case ('toggle') {
                    <app-yes-no-question
                      [form]="supplierForm"
                      [question]="question"
                      class="w-100">
                    </app-yes-no-question>
                  }
                  @case ('2scale') {
                    <app-scale
                      [form]="supplierForm"
                      [question]="question"
                      class="w-100">
                    </app-scale>
                  }
                  @case ('3scale') {
                    <app-scale
                      [form]="supplierForm"
                      [question]="question"
                      class="w-100">
                    </app-scale>
                  }
                  @case ('dropdown') {
                    <div class=" question w-100 d-flex mb-2" >
                      <span class="mb-2 w-50">{{ question.text }}</span>
                      <ng-select  class="dropdown w-50" [formControlName]="question.uniqueId" [items]="dropDownItemsMap[question.uniqueId]" bindLabel="text" bindValue="id"
                        [multiple]="false" [clearable]="false" [searchable]="true">
                      </ng-select>
                    </div>
                  }
                  @case ('date') {
                    <div class="w-100 d-flex mb-2 question">
                      <span class="mb-2 w-50">{{ question.text }}</span>
                      <input  type="text" [formControlName]="question.uniqueId"
                        class="form-control w-50" [matDatepicker]="supplierDatePicker"
                        onkeydown="return false" readonly autocomplete="off"
                        (click)="supplierDatePicker.open()" (focus)="supplierDatePicker.open()"/>
                      <mat-datepicker #supplierDatePicker></mat-datepicker>
                      </div>
                    }
                    @case ('number') {
                      <div class="w-100 d-flex mb-2 question">
                        <span class="mb-2 w-50">{{ question.text }}</span>
                        <input #inputNumber [formControlName]="question.uniqueId" type="number"
                          class="form-control w-50 "/>
                        </div>
                      }
                      @case ('freeText') {
                        <div class="w-100 text-center question">
                          <span class="d-block mb-2">{{ question.text }}</span>
                          <textarea [formControlName]="question.uniqueId"
                            [attr.maxlength]="question.max_length"
                            class="text-etape form-control w-100"
                            rows="4">
                          </textarea>
                        </div>
                      }
                    }
                  </ng-container>
                }
              </div>
            }
          </div>
          <div class="mt-3 pt-2 w-100 d-flex justify-content-center">
            <button type="submit"
              class="btn btn-primary action-button"
              [disabled]="supplierForm.pristine">
              <i class="fas fa-save me-2"></i>{{'SURVEY.SUBMIT' | translate }}
            </button>
          </div>
        </form>
      }
    </div>

